import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id D0B20B31-ADBD-4F8A-9B72-52CC2FE4C3F4
 * name currency-mnt
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-mnt.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyMntIcon = createSvgIcon(<><path d="M13 5V8.62L17 7.17V9.29L13 10.74V12.5L17 11.07V13.2L13 14.65V21H11V15.38L7 16.84V14.71L11 13.24V11.47L7 12.92V10.8L11 9.35V5H5V3H19V5H13Z" /></>, 'CurrencyMntIcon');
export default CurrencyMntIcon